import { getActiveBrandConfig, getActivePrestationBrandConfig } from "../../config/environment.config";

/** Écran « Mes cours » : `/{marque}/tableau-de-bord/{prestation}`. */
export const coursesPath = (): string => `/${getActiveBrandConfig()}/tableau-de-bord/${getActivePrestationBrandConfig()}`;

/** Page de modification d'un cours à venir ou du mois : `/{marque}/tableau-de-bord/{prestation}/modifier/{id}`. */
export const courseEditPath = (id: number | string): string => `${coursesPath()}/modifier/${id}`;
